// src/styles/GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    font-family: ${props => props.theme.fonts.main};
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.textPrimary};
    margin: 0;
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3 {
    color: ${props => props.theme.colors.textPrimary};
    font-weight: 700;
    /* This negative letter spacing is the key "Buildify" detail */
    letter-spacing: -0.025em; 
    line-height: 1.1;
  }

  p {
    color: ${props => props.theme.colors.textSecondary};
    line-height: 1.6;
    font-size: 1.1rem;
  }

  button {
    font-family: ${props => props.theme.fonts.main};
    font-weight: 600;
  }
`;